export default [
    {
        url: "/dashboard",
        name: "Dashboard",
        icon: "dashboard"
    },
    {
      url: '/courses',
      name: 'Courses',
      icon: "class"
    },
    {
        url: '/docs',
        name: 'Documentation',
        icon: 'description'
    },

]
